import { Button, Card, Grid } from '@material-ui/core';
import React, { useEffect } from 'react'
import BuscadorAbm from '../../compartidos/abms/BuscadorAbm';
import TableGeneric from '../../compartidos/abms/TableGeneric';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { buscarUsuariosOspeDirecto, getUsuariosOspedycDirecto } from '../../../actions/tesoreria/usuariosOspeDirectoActions';
import { FormUsuariosOspeDirecto } from './FormUsuariosOspeDirecto';
import ModalAbm from '../../compartidos/abms/ModalAbm';



export const UsuariosOspeDirectoHome = (props) => {

    const dispatch = useDispatch();


    const [open, setOpen] = useState(false)
    const [itemForm, setItemForm] = useState(null)
    const { items } = useSelector((state) => state.usuariosOspeDirecto);

    const handleSearch = (textoBuscado) => {
        dispatch(buscarUsuariosOspeDirecto(textoBuscado));
    }

    const handleItemSelect = (item) => {
        setItemForm(item)
        setOpen(true)
    }

    useEffect(() => {
        dispatch(getUsuariosOspedycDirecto())
    }, [dispatch])



    return (
        <div>
            <Grid container justify="center">
                {/* <ModalAbm title="Agregar Material" open={openModalAlta} setOpen={setOpenModalAlta}>
                    <FormMateriales formData={intialValue} handleSave={handleSave} cerrarModal={() => setOpenModalAlta(false)} permisoAlta={MATERIALES.ALTA} editando={false} />
                </ModalAbm> */}
                <ModalAbm title="Enviar Usuario por mail" open={open} setOpen={setOpen}>
                    <FormUsuariosOspeDirecto formData={itemForm} cerrarModal={() => setOpen(false)} />
                </ModalAbm>
                {/* <Grid item xs={12}>
                    <Button variant="contained" color="primary" onClick={() => setOpenModalAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar Material</Button>
                </Grid> */}
                <Grid item xs={12} md={5} style={{marginTop : 10 }}>
                    <BuscadorAbm title="Buscar Efector" handleSearch={handleSearch} />
                </Grid>

                <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
                    <Card>
                        <TableGeneric
                            data={items}
                            columns={[
                                // {
                                //     label: "",
                                //     customBody: (item) => (
                                //         <AccionesGenericoAbm
                                //             item={item}
                                //             handleItemSelect={handleItemSelect}
                                //             //permisoDelete={null}
                                //             //handleDelete={handleDelete}
                                //             showSelect={true}
                                //             showDelete={false}
                                //         />
                                //     )
                                // },
                                {
                                    label: "Id Efector",
                                    id: "idEfectorRed",
                                    sort: true
                                },
                                {
                                    label: "Efector",
                                    id: "razonSocial",
                                    sort: true
                                },
                                {
                                    label: "Usuario Ventanilla electrónica",
                                    id: "usuarioVentanilla",
                                    sort: true
                                },
                                {
                                    label: "Contraseña Ventanilla electrónicao",
                                    id: "passwordVentanilla",
                                    sort: true
                                },
                                {
                                    label: "Envio Usuario",
                                    customBody: (item) => (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            onClick={() => handleItemSelect(item)}
                                            type='submit'
                                        >
                                            ENVIAR
                                        </Button>
                                    )
                                },
                            ]}
                        />
                    </Card>
                </Grid>
            </Grid>
        </div>
    )
}
